
import senadoFooterLogo from "@/core/assets/img/cabecalhos-pdf/senado-footer.jpg";
/**
 * colocar imgem de rodape na impressao
 */

export function createFooterSenado(doc) {
    doc.addImage(senadoFooterLogo, "JPEG", 260, 197, 25, 12);
  doc.setFontSize(12);
  doc.setFont("", "bold");
  doc.text(
    "____________________________________________________________________________________________________________________________________",
    10,
    196,
    null,
    null
  );

  doc.setFont("", "normal");

  return doc;
}
